import React from 'react';
import ReactDOM from 'react-dom';

interface Props {
  children: React.ReactNode | React.ReactNode[];
  disabled?: boolean;
}

export const Portal: React.FC<Props> = (props: Props) => {
  const { children, disabled = false } = props;

  const [portalNode, setPortalNode] = React.useState<HTMLElement | null>(null);

  React.useEffect(() => {
    if (!disabled) {
      setPortalNode(document.body);
    }
  }, [disabled]);

  if (disabled) return <React.Fragment>{children}</React.Fragment>;

  return portalNode ? ReactDOM.createPortal(children, portalNode) : portalNode;
};

export default Portal;
